// extracted by mini-css-extract-plugin
export var badge = "unified-search-result-grid-item-module--badge--acf3e";
export var bestPractice = "unified-search-result-grid-item-module--bestPractice--332c7";
export var certificate = "unified-search-result-grid-item-module--certificate--287f5";
export var course = "unified-search-result-grid-item-module--course--3d67d";
export var courseStatus = "unified-search-result-grid-item-module--courseStatus--209cb";
export var description = "unified-search-result-grid-item-module--description--21f74";
export var divider = "unified-search-result-grid-item-module--divider--0ffa8";
export var gettingStarted = "unified-search-result-grid-item-module--gettingStarted--ea2f0";
export var liveTraining = "unified-search-result-grid-item-module--liveTraining--905ce";
export var onDarkBackground = "unified-search-result-grid-item-module--onDarkBackground--999bb";
export var partnerPill = "unified-search-result-grid-item-module--partnerPill--7c760";
export var pillContainer = "unified-search-result-grid-item-module--pillContainer--db28f";
export var postContent = "unified-search-result-grid-item-module--postContent--3aad1";
export var quickGuide = "unified-search-result-grid-item-module--quickGuide--a1b7f";
export var searchResult = "unified-search-result-grid-item-module--searchResult--04d02";
export var title = "unified-search-result-grid-item-module--title--11631";
export var truncate = "unified-search-result-grid-item-module--truncate--3cfb7";